import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'lib-sow',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './sow.component.html',
  styleUrls: ['./sow.component.scss'],
})
export class SowComponent {}
